import { useLazyQuery } from '@apollo/client'
import { GetCompanyMembers, GetCompanyMembersVariables } from '../../types'
import { GET_COMPANY_MEMBERS } from './operations'

export const useCompanyMembersQuery = () => {
  const companyMembersQuery = useLazyQuery<GetCompanyMembers, GetCompanyMembersVariables>(
    GET_COMPANY_MEMBERS
  )
  return {
    companyMembersQuery,
    query: GET_COMPANY_MEMBERS,
  }
}
